/*
 * @desc 处理数据逻辑
 * @Author: wita.wang 
 * @Date: 2022-11-20 17:26:49 
 * @Last Modified by: wita.wang
 * @Last Modified time: 2024-07-19 18:41:20
 */

export default class UtilEvent{
    constructor(){
        //总开关，是否打开静态数据
        this.totalFlag = false;
        this.isGrayModel = false;
    }
    /**
     * 获取当前语言后缀
     * @returns {string} 语言后缀，如 '_en' 或 ''
     */
    getLangSuffix(){
        let lang = localStorage.getItem('localeLanguage') || 'zh';
        if (lang === 'en') {
            return '_en';
        }else {
            return '';
        }
        return '';
    }
    /**
     * 默哀模式
     */
    initSystemModel(){
        if(this.isGrayModel == true){
            document.getElementsByTagName("html")[0].style.filter = "progid:DXImageTransform.Microsoft.BasicImage(graysale=1)";
            document.getElementsByTagName("html")[0].style["-webkit-filter"] = "grayscale(100%)"
        }
    }
    /**
     * 获得首页数据
     * @param {*} _this 
     */
    getMainData(_this){
        //静态
        if(this.totalFlag){
            _this.mainData = require('../../../store/json/mainInfo.json');
        }else{
            _this.$httpUtil.sendGet(_this, '/iksnet_api/mainInfo.json',  { }, function (sucess, res) {
                _this.mainData = res
              });
        }
    }
    /**
     * 获得新闻动态列表
     * @param {*} _this 
     */
     getNewsListData(_this){
        //静态
        if(this.totalFlag){
            _this.newsList = require('../../../store/json/newsList.json');
            _this.perPage = _this.newsList.perPage;
        }else{
            _this.$httpUtil.sendGet(_this, '/iksnet_api/newsList.json',  { }, function (sucess, res) {
                _this.newsList = res
                _this.perPage = _this.newsList.perPage;
              });
        }
    }
    /**
     * 获得公告列表
     * @param {*} _this 
     */
     getAnnoListData(_this){
        //静态
        if(this.totalFlag){
            let newsList = require('../../../store/json/inv-newsList.json');
            _this.conditionNewsList = JSON.parse(JSON.stringify(newsList))
            
        }else{
            let langSuffix = this.getLangSuffix();
            _this.$httpUtil.sendGet(_this, '/iksnet_api/announcementReport' + langSuffix + '.json',  { }, function (sucess, res) {
                if(sucess && res && res.list){
                    let data = JSON.parse(JSON.stringify(res));
                    if(_this.$set){
                        _this.$set(_this, 'conditionNewsList', data);
                    }else{
                        _this.conditionNewsList = data;
                    }
                }else{
                    // 找不到英文版本，返回空数组
                    let emptyData = {total:0, perPage:1, yearList:[], list:[]};
                    if(_this.$set){
                        _this.$set(_this, 'conditionNewsList', emptyData);
                    }else{
                        _this.conditionNewsList = emptyData;
                    }
                }
              });
        }
    }
    /**
     * 获得新闻稿列表
     * @param {*} _this 
     */
    getNoticeListData(_this){
        //静态
        if(this.totalFlag){
            let newsList = require('../../../store/json/inv-newsNotice.json');
            _this.conditionNoticeList = JSON.parse(JSON.stringify(newsList))
            
        }else{
            let langSuffix = this.getLangSuffix();
            _this.$httpUtil.sendGet(_this, '/iksnet_api/newsReport' + langSuffix + '.json',  { }, function (sucess, res) {
                if(sucess && res && res.list){
                    let data = JSON.parse(JSON.stringify(res));
                    // 使用Vue.set确保响应式更新
                    if(_this.$set){
                        _this.$set(_this, 'conditionNoticeList', data);
                    }else{
                        _this.conditionNoticeList = data;
                    }
                }else{
                    // 找不到英文版本，返回空数组
                    let emptyData = {total:0, perPage:1, yearList:[], list:[]};
                    if(_this.$set){
                        _this.$set(_this, 'conditionNoticeList', emptyData);
                    }else{
                        _this.conditionNoticeList = emptyData;
                    }
                }
              });
        }
    }
    /**
     * 电话会议列表
     * @param {*} _this 
     */
    getTelMeetingListData(_this){
        //静态
        if(this.totalFlag){
            let newsList = require('../../../store/json/inv-telMeetingList.json');
            _this.telMeetingList = JSON.parse(JSON.stringify(newsList))
            
        }else{
            // let langSuffix = this.getLangSuffix();
            _this.$httpUtil.sendGet(_this, '/iksnet_api/telConferenceReport.json',  { }, function (sucess, res) {
                if(sucess && res){
                    let data = JSON.parse(JSON.stringify(res));
                    if(_this.$set){
                        _this.$set(_this, 'telMeetingList', data);
                    }else{
                        _this.telMeetingList = data;
                    }
                }
              });
        }
    }
    /**
     * 投资者活动列表（新闻类型）
     * @param {*} _this 
     */
    getInvestorEventData(_this){
        //静态
        if(this.totalFlag){
            let eventData = require('../../../store/json/inv-eventCalendar.json');
            _this.investorEventData = JSON.parse(JSON.stringify(eventData))
            
        }else{
            let langSuffix = this.getLangSuffix();
            _this.$httpUtil.sendGet(_this, '/iksnet_api/eventCalendar' + langSuffix + '.json',  { }, function (sucess, res) {
                if(sucess && res && res.list){
                    let data = JSON.parse(JSON.stringify(res));
                    if(_this.$set){
                        _this.$set(_this, 'investorEventData', data);
                    }else{
                        _this.investorEventData = data;
                    }
                }else{
                    // 找不到英文版本，返回空数组
                    let emptyData = {total:0, perPage:12, yearList:[], list:[]};
                    if(_this.$set){
                        _this.$set(_this, 'investorEventData', emptyData);
                    }else{
                        _this.investorEventData = emptyData;
                    }
                }
              });
        }
    }
    /**
     * 获得投资者活动详情
     * @param {*} _this 
     */
    getInvestorEventDetail(_this){
        //静态
        if(this.totalFlag){
            _this.detailData = require('../../../store/json/newDetail_111111.json');
            
        }else{
            let langSuffix = this.getLangSuffix();
            _this.$httpUtil.sendGet(_this, '/iksnet_api/news/' + _this.$route.query.detailId + langSuffix + '.json',  { }, function (sucess, res) {
                if(sucess && res){
                    _this.detailData = res;
                }else{
                    // 英文版本不存在时，尝试加载中文版本
                    _this.$httpUtil.sendGet(_this, '/iksnet_api/news/' + _this.$route.query.detailId + '.json',  { }, function (sucess2, res2) {
                        _this.detailData = res2 || {};
                    });
                }
              });
        }
    }
    /**
     * 财务报告--年度报告
     * @param {*} _this 
     */
    getFinYearsReportListData(_this){
        //静态
        if(this.totalFlag){
            let newsList = require('../../../store/json/inv-yearsReportList.json');
            _this.finYearsReportList = JSON.parse(JSON.stringify(newsList))
            
        }else{
            let langSuffix = this.getLangSuffix();
            _this.$httpUtil.sendGet(_this, '/iksnet_api/yearsReport' + langSuffix + '.json',  { }, function (sucess, res) {
                if(sucess && res && res.list){
                    let data = JSON.parse(JSON.stringify(res));
                    if(_this.$set){
                        _this.$set(_this, 'finYearsReportList', data);
                    }else{
                        _this.finYearsReportList = data;
                    }
                }else{
                    // 找不到英文版本，返回空数组
                    let emptyData = {total:0, perPage:12, yearList:[], list:[]};
                    if(_this.$set){
                        _this.$set(_this, 'finYearsReportList', emptyData);
                    }else{
                        _this.finYearsReportList = emptyData;
                    }
                }
              });
        }
    }
    /**
     * 财务报告--季度度报告
     * @param {*} _this 
     */
     getFinQuarterReportListData(_this){
        //静态
        if(this.totalFlag){
            let newsList = require('../../../store/json/inv-quartsReportList.json');
            _this.quarterReportList = JSON.parse(JSON.stringify(newsList))
            
        }else{
            let langSuffix = this.getLangSuffix();
            _this.$httpUtil.sendGet(_this, '/iksnet_api/quartersReport' + langSuffix + '.json',  { }, function (sucess, res) {
                if(sucess && res && res.list){
                    let data = JSON.parse(JSON.stringify(res));
                    if(_this.$set){
                        _this.$set(_this, 'quarterReportList', data);
                    }else{
                        _this.quarterReportList = data;
                    }
                }else{
                    // 找不到英文版本，返回空数组
                    let emptyData = {total:0, perPage:12, yearList:[], list:[]};
                    if(_this.$set){
                        _this.$set(_this, 'quarterReportList', emptyData);
                    }else{
                        _this.quarterReportList = emptyData;
                    }
                }
              });
        }
    }
     /**
     * 企业管治文件
     * @param {*} _this 
     */
      getBusinessFileListData(_this){
        //静态
        if(this.totalFlag){
            let newsList = require('../../../store/json/inv-businessFiletList.json');
            _this.businessFileList = JSON.parse(JSON.stringify(newsList))
            
        }else{
            let langSuffix = this.getLangSuffix();
            _this.$httpUtil.sendGet(_this, '/iksnet_api/businessFileReport' + langSuffix + '.json',  { }, function (sucess, res) {
                if(sucess && res && res.list){
                    let data = JSON.parse(JSON.stringify(res));
                    if(_this.$set){
                        _this.$set(_this, 'businessFileList', data);
                    }else{
                        _this.businessFileList = data;
                    }
                }else{
                    // 找不到英文版本，返回空数组
                    let emptyData = {total:0, perPage:12, yearList:[], list:[]};
                    if(_this.$set){
                        _this.$set(_this, 'businessFileList', emptyData);
                    }else{
                        _this.businessFileList = emptyData;
                    }
                }
              });
        }
    }
    /**
     * 获得新闻详情
     * @param {*} _this 
     */
     getNewsDetail(_this){
        //静态
        if(this.totalFlag){
            _this.detailData = require('../../../store/json/newDetail_111111.json');
            
        }else{
            _this.$httpUtil.sendGet(_this, '/iksnet_api/news/' + _this.$route.query.detailId + '.json',  { }, function (sucess, res) {
                _this.detailData = res
              });
        }
    }
     /**
     * 获得社会责任
     * @param {*} _this 
     */
      getSocityInfo(_this){
        //静态
        if(this.totalFlag){
            _this.socityData = require('../../../store/json/socialDutyReport.json');

        }else{
            let langSuffix = this.getLangSuffix();
            _this.$httpUtil.sendGet(_this, '/iksnet_api/socialDutyReport' + langSuffix + '.json',{}, function (sucess, res) {
                if(sucess && res){
                    let data = JSON.parse(JSON.stringify(res));
                    if(_this.$set){
                        _this.$set(_this, 'socityData', data);
                    }else{
                        _this.socityData = data;
                    }
                    //去除第一条放在大模块中
                    let arrayTemp = JSON.parse(JSON.stringify(data.list));
                    arrayTemp.shift();
                    _this.listShift = arrayTemp;
                    _this.totalNum = _this.listShift.length;
                    _this.pageCount = _this.$PageUtil.getPageCount(_this.totalNum, _this.perPage);
                    //获得第一页数据
                    _this.showList = _this.$PageUtil.getStaticPage(1, _this.perPage, _this.listShift);
                }else{
                    _this.socityData = {total:0, list:[]};
                    _this.listShift = [];
                    _this.showList = [];
                    _this.pageCount = 1;
                }
              });
        }
    }
    /**
     * 获得招聘信息
     * @param {*} _this 
     */
    getRecruitList(_this){
        //静态
        if(this.totalFlag){
            _this.recruitData = require('../../../store/json/recruitList.json');
            _this.recruitDataSource = JSON.parse(JSON.stringify(_this.recruitData));
        }else{
            debugger
            _this.$httpUtil.sendGet(_this, '/iksnet_api/recruit/recruitList.json',{}, function (sucess, res) {
                _this.recruitData = res
                _this.recruitDataSource = JSON.parse(JSON.stringify(_this.recruitData));
                // _this.socityData = require('../../../store/json/socialDutyReport.json');
                //去除第一条放在大模块中
                // let arrayTemp = JSON.parse(JSON.stringify(_this.socityData.list));
                // arrayTemp.shift();
                // _this.listShift = arrayTemp
                // _this.totalNum = _this.listShift.length ;
                // _this.pageCount = _this.$PageUtil.getPageCount(_this.totalNum,_this.perPage);
                // //获得第一页数据
                // _this.showList = _this.$PageUtil.getStaticPage(1,_this.perPage,_this.listShift);
              });
        }
    }
    //获取招聘详细信息
    getRecruitDetail(_this,selectId){
        //静态
        if(this.totalFlag){
            let recruitData = require('../../../store/json/recruitList.json');
            let listData  = recruitData.list;
            let itemDetail = listData.find(item => item.id === selectId)
            _this.detailData = itemDetail;
            
        }else{
            _this.$httpUtil.sendGet(_this, '/iksnet_api/recruit/recruitList.json',{}, function (sucess, res) {
                let listData  = res.list;
                let itemDetail = listData.find(item => item.id === selectId)
                _this.detailData = itemDetail;
              });
        }
    }
    getRecruitByConditions(_this,conditions){
        return items.filter(item => {
            return Object.keys(conditions).every(key => {
                return item[key] === conditions[key];
            });
        });
    }
    
    
}
    